/**
 * Vuex module for conferences.
 */
import debug from 'debug'
import API from '@/api'
import CDR from 'Store/class/cdr'

const dbg = debug('store:action:cdrs:')

const actions = {
  loadPage: function ({ commit, state }) {
    dbg(`Load CDRs from API page ${state.pagination.page}`)
    const start = state.pagination.start
    const offset = state.pagination.perPage
    const fromDate = state.filter.fromDate
    const toDate = state.filter.toDate
    const exten = state.extensions
    return API.getCDRs(start, offset, fromDate, toDate, exten).then(resp => {
      commit('RESET')
      resp.data.data.forEach(rec => {
        commit('ADD_NEW', rec)
      })
      commit('SET_TOTAL', resp.data.total)
    })
  },

  getWatchedUsers: function ({ commit }) {
    return API.getCDRUsers().then(resp => {
      if (resp.data && resp.data.length > 0) {
        resp.data.forEach(user => {
          commit('SET_WATCH_USER', user)
        })
      }
    })
  },

  setPage: function ({ commit }, page) {
    commit('SET_PAGE', page)
  },

  setStartDate: function ({ commit }, val) {
    commit('SET_START_DATE', val)
  },

  setEndDate: function ({ commit }, val) {
    commit('SET_END_DATE', val)
  },

  setExtensions: function ({ commit }, val) {
    commit('SET_EXTENSIONS', val)
  },

  setPerPage ({ commit }, perPage) {
    commit('SET_PER_PAGE', perPage)
  },

  updateCDR ({ commit }, { id, data }) {
    commit('UPDATE_CDR', { id, data })
  },

  downloadCDRsAsCSV ({ commit, state }) {
    const fromDate = state.filter.fromDate
    const toDate = state.filter.toDate
    const exten = state.extensions
    return API.getCDRsCSV(fromDate, toDate, exten).then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'cdrs.csv')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    })
  }
}

const mutations = {
  SET_PAGE (state, page) {
    page = page || state.pagination.curPage
    state.pagination.curPage = page
    state.pagination.start = (page - 1) * state.pagination.perPage
  },

  SET_TOTAL (state, total) {
    state.pagination.total = total
    state.pagination.pages = Math.ceil(total / state.pagination.perPage)
  },

  RESET (state) {
    state.cdrs.splice(0)
  },

  ADD_NEW (state, rec) {
    state.cdrs.push(new CDR(rec))
  },

  UPDATE_CDR (state, { id, data }) {
    if (!data || !id) {
      return
    }
    const index = state.cdrs.findIndex(cdr => cdr.id === id)
    if (index > -1) {
      Object.assign(state.cdrs[index], data)
    }
  },

  SET_START_DATE (state, val) {
    state.filter.fromDate = val
  },

  SET_END_DATE (state, val) {
    state.filter.toDate = val
  },

  SET_WATCH_USER (state, user) {
    state.watchUsers.push(user)
  },

  SET_EXTENSIONS (state, extensions) {
    state.extensions = extensions
  },

  SET_PER_PAGE (state, perPage) {
    state.pagination.perPage = perPage
  }
}

const state = {
  cdrs: [],
  pagination: {
    total: 0,
    perPage: 18,
    curPage: 1,
    pages: 0,
    start: 0
  },
  watchUsers: [],
  extensions: [],
  filter: {
    fromDate: null,
    toDate: null,
    userExten: null
  }
}

const getters = {
  list: state => state.cdrs,
  fromDate: state => state.filter.fromDate,
  pagination: state => state.pagination,
  total: state => state.pagination.total,
  toDate: state => state.filter.toDate,
  watchUsers: state => state.watchUsers,
  extensions: state => state.extensions
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
